import { Fragment, useState } from 'react';

import { trans } from '@spotahome/soyuz/client';

import { DSIcon } from '@spotahome/ui-library/base';

import Switcher from '@spotahome/ui-library/src/tenant/components/Switcher';
import LazyLoad from '@spotahome/ui-library/src/tenant/components/LazyLoad';
import LandingSection from '@spotahome/landings-common/src/components/LandingSection';

import Quote from '../Quote/Quote';
import LogoText from '../LogoText';

import './SecurityDeposit.scss';

const SWITCHER_HEIGHT = 64;

const SecurityDepositSection = ({ title, sections }) => {
  return (
    <Fragment>
      <p className="tenant-guarantees-security-deposit-section__main-title">
        {title}
      </p>
      {sections.map(section => (
        <div
          className="tenant-guarantees-security-deposit-section__item"
          key={section.title}
        >
          <DSIcon
            name={section.icon}
            className="tenant-guarantees-security-deposit-section__icon"
            size="ml"
          />
          <div>
            <p className="tenant-guarantees-security-deposit-section__title">
              {trans(section.title)}
            </p>
            <p className="tenant-guarantees-security-deposit-section__description">
              {trans(section.description)}
            </p>
          </div>
        </div>
      ))}
    </Fragment>
  );
};

const COVERS_SECTIONS = [
  {
    title: 'tenant_guarantees.deposit.cover.1.title',
    icon: 'delete_history',
    description: 'tenant_guarantees.deposit.cover.1.description'
  },
  {
    title: 'tenant_guarantees.deposit.cover.2.title',
    icon: 'check_circle_transparent',
    description: 'tenant_guarantees.deposit.cover.2.description'
  },
  {
    title: 'tenant_guarantees.deposit.cover.3.title',
    icon: 'event_available',
    description: 'tenant_guarantees.deposit.cover.3.description'
  }
];
const CLAIM_SECTIONS = [
  {
    title: 'tenant_guarantees.deposit.claim.1.title',
    icon: 'animated_images',
    description: 'tenant_guarantees.deposit.claim.1.description'
  },
  {
    title: 'tenant_guarantees.deposit.claim.2.title',
    icon: 'check_circle_transparent',
    description: 'tenant_guarantees.deposit.claim.2.description'
  },
  {
    title: 'tenant_guarantees.deposit.claim.3.title',
    icon: 'support_agent',
    description: 'tenant_guarantees.deposit.claim.3.description'
  }
];

const SecurityDeposit = () => {
  const [showCovers, setShowCovers] = useState(true);

  const handleSectionSwitch = () => {
    setShowCovers(!showCovers);
  };
  return (
    <Fragment>
      <LandingSection containerClassName="tenant-guarantees-security-deposit__section-container">
        <LogoText />
        <h2 className="tenant-guarantees-security-deposit__title">
          {trans('tenant_guarantees.deposit.title')}
        </h2>
        <div className="tenant-guarantees-security-deposit__wrapper">
          <LazyLoad
            offset={100}
            once
            as="figure"
            className="tenant-guarantees-security-deposit__image"
          >
            <img
              src="https://static.spotahome.com/images/tenant-guarantee-deposit.webp"
              alt="Security Deposit"
            />
          </LazyLoad>
          <div className="tenant-guarantees-security-deposit__protection">
            <Switcher
              onClickLeft={handleSectionSwitch}
              onClickRight={handleSectionSwitch}
              className="tenant-guarantees-security-deposit__switcher"
              renderLeftIcon={() => (
                <span>
                  {trans('tenant_guarantees.deposit.switcher.covers')}
                </span>
              )}
              renderRightIcon={() => (
                <span>{trans('tenant_guarantees.deposit.switcher.claim')}</span>
              )}
              colorSchema="interaction-transparent"
              height={SWITCHER_HEIGHT}
              dataTest="security-deposit-switcher"
            />
            <SecurityDepositSection
              title={
                showCovers
                  ? trans('tenant_guarantees.deposit.cover.title')
                  : trans('tenant_guarantees.deposit.claim.title')
              }
              sections={showCovers ? COVERS_SECTIONS : CLAIM_SECTIONS}
            />
          </div>
        </div>
      </LandingSection>
      <Quote />
    </Fragment>
  );
};

export default SecurityDeposit;
